import { Calendar, Database, Mail, MessageSquare, Plug } from "lucide-react";

const items = [
  {
    icon: MessageSquare,
    label: "Website Chat",
    desc: "Conversational widget answers FAQs and books appointments.",
  },
  { icon: Mail, label: "Email/SMS", desc: "Automated follow‑ups, reminders, and status updates." },
  {
    icon: Calendar,
    label: "Calendar",
    desc: "Syncs with Google and Outlook to avoid double‑booking.",
  },
  {
    icon: Database,
    label: "CRM/EHR",
    desc: "Clio, Dentrix, HubSpot and more via secure connectors.",
  },
  { icon: Plug, label: "Other Apps", desc: "Zapier/Make for flexible no‑code integrations." },
];

const ConnectStrip = () => {
  return (
    <section aria-label="How It Connects" className="py-10 md:py-14 grain-overlay bg-canvas">
      <div className="container mx-auto">
        <h3 className="text-2xl md:text-3xl font-semibold font-display mb-6">How It Connects</h3>

        {/* Mobile: horizontal scroll; Desktop: 5-column grid */}
        <div
          className="grid grid-flow-col auto-cols-[minmax(240px,1fr)] gap-4 overflow-x-auto snap-x snap-mandatory md:grid-flow-row md:auto-cols-auto md:grid-cols-5 md:overflow-visible"
        >
          {items.map(({ icon: Icon, label, desc }) => (
            <div
              key={label}
              className="snap-start rounded-lg border bg-card text-card-foreground shadow-sm p-4 flex items-start gap-3 h-full"
            >
              <span className="inline-flex items-center justify-center rounded-md bg-secondary p-2 self-start">
                <Icon className="text-primary" aria-hidden />
              </span>
              <div className="space-y-1">
                <p className="font-medium leading-tight">{label}</p>
                <p className="text-base text-cream-muted leading-snug line-clamp-3">{desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConnectStrip;
